import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="What's included" className="border-y border-plum/10 bg-plum" data-id="element-250" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-6" data-id="element-251" data-mp="2wvdw1xw5464u">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-252" data-mp="2ix5sh74lm6kp">
          {stats.map(s => <div key={s.label} className="flex flex-col-reverse text-center" data-id="element-253" data-mp="2nvz8p7b9sbok">
              <dt className="mt-1 text-sm font-medium text-white/65" data-id="element-254" data-mp="297m7nvxbs2n7">{s.label}</dt>
              <dd className="font-display text-4xl font-black text-grape-soft sm:text-5xl" data-id="element-255" data-mp="2dyuld45oua66">{s.value}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}